import { render, staticRenderFns } from "./MultiTagsSelector.vue?vue&type=template&id=21a94b59&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./MultiTagsSelector.vue?vue&type=script&lang=js&"
export * from "./MultiTagsSelector.vue?vue&type=script&lang=js&"
import style0 from "./MultiTagsSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MultiTagsSelector.vue?vue&type=style&index=1&id=21a94b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a94b59",
  null
  
)

export default component.exports